import { useAuth } from "@/context/AuthContext";
import TeacherDashboard from "@/pages/Dashboard";
import StudentDashboard from "@/pages/StudentDashboard";
import CohortDashboard from "@/pages/CohortDashboard";
import CompanyDashboard from "@/pages/CompanyDashboard";

export default function DashboardHome() {
  const { user } = useAuth();
  if (user?.role === "student") return <StudentDashboard />;
  if (user?.role === "cohort") return <CohortDashboard />;
  if (user?.role === "admin") return <CompanyDashboard />;
  return <TeacherDashboard />;
}
